export default __webpack_public_path__ + "static/media/le_touquet20.6dcd41b3.jpg";